import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'formattatimespan'
})

export class FormattaTimespanPipe implements PipeTransform {

    /** in base al parametro passato si setta l'ora locale
     * @param  {any} value
     */
    transform(value: any ): string {
        let valore : string = "";
        if (value != null) {
            let data = new Date(value * 1000);
            valore = data.toLocaleDateString(localStorage.getItem('locale') || 'it');
        }
        return valore;
    }
}